import React, { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { render } from 'base/wrapped-render-v2';
import { getMaxZIndex } from '@utils/dom';
import { BasicSlidedown } from '@bamboohr/fabric';
import { ifFeature } from '@bamboohr/utils/lib/feature';

let root;

const AlertContainer = () => {
	const slidedownRef = useRef(null);

	useEffect(() => {
		if (slidedownRef.current) {
			window.bambooAlert = slidedownRef.current;
			window.closeMessage = slidedownRef.current.hideAlert;

			if (window._queuedAlerts && window._queuedAlerts.length) {
				window._queuedAlerts.forEach((alertArgs) => {
					window.bambooAlert.setAlert(...alertArgs);
				})
				window._queuedAlerts = [];
			}
		}
	}, [])

	return (
		<BasicSlidedown
			ref={ (slidedown) => { slidedownRef.current = slidedown; } }
			showOnMount={ false }
		/>
	)
}

export const initializeBambooAlerts = () => {

	// if a page doesn't have the new `js-sessionMessage` element, fall back to the old `sessionMessage` element
	const container = document.getElementById(ifFeature('encore', 'js-sessionMessage', 'sessionMessage')) || document.getElementById('sessionMessage');

	if (container) {
		root ||= createRoot(container);
		window._queuedAlerts ||= [];
		render({
			children: (
				<AlertContainer />
			),
			root,
		});
		window.setMessage = (...args) => {
			const currentMax = getMaxZIndex();

			if (container.style.zIndex !== `${ currentMax }`) {
				container.style.zIndex = currentMax + 10;
			}
			if (window.bambooAlert) {
				window.bambooAlert.setAlert(...args);
			} else {
				window._queuedAlerts.push(args);
			}
		};
	}
};

export const displaySessionMessage = (message) => {
	if (message && message.text) {
		window.setTimeout(() => window.setMessage(message.text, message.type), 0);
	}
};
